import type { SessionLifecycleStatus } from "../../shared/types.ts";

export async function prepareLiveCaptureSession<TConfig>(input: {
  sessionId: string;
  liveConfig: TConfig | null;
  ensureSessionActive: (sessionId: string) => Promise<void> | void;
  saveSttConfig: (config: TConfig) => Promise<void> | void;
}): Promise<void> {
  await input.ensureSessionActive(input.sessionId);
  if (input.liveConfig) await input.saveSttConfig(input.liveConfig);
}

export function shouldStopCaptureForSessionChange(input: {
  previousSessionId: string;
  nextSessionId: string;
  captureActive: boolean;
}): boolean {
  return input.captureActive && input.previousSessionId !== input.nextSessionId;
}

export function shouldStopCaptureForSessionStatus(input: {
  sessionStatus: SessionLifecycleStatus;
  captureActive: boolean;
}): boolean {
  return input.captureActive &&
    (input.sessionStatus === "closed" || input.sessionStatus === "archived");
}
